import VinculosAtivosRedesign from "@/components/consignado/Cobranca/VinculosAtivosRedesign";

// Tela "Vínculos Ativos" (redesign). O container faz as queries: nível 1
// (empregadores, rota real paginada), nível 2 (CCBs por empregador, rota real)
// e o detalhe da CCB com uma query real por seção. O que ainda é mock está
// rotulado com <MockData> (ver EmpresaRow / CcbDetalhe).
export default function VinculosAtivosPage() {
  return <VinculosAtivosRedesign />;
}
